var path = '/app/components/dialogs/apresentation/apresentation.html';
var html = "<div class=custom-modal-wrap> <div class=custom-modal> <div class=modal-body id=modal-body> <div class=sentences> <div class=sentence ng-repeat=\"s in $ctrl.resolve.texts\" ng-show=\"$ctrl.state.step == $index\"> <div class=sentence-content ng-bind-html=s></div> </div> </div> <a class=btn-next ng-click=$ctrl.nextStep() ng-class=\"{ 'disabled': $ctrl.state.step == ( $ctrl.resolve.texts.length - 1 ) }\"></a> </div> <a class=btn-text-back ng-click=$ctrl.cancel()></a> <a class=btn-activity ng-click=$ctrl.ok() ng-class=\"{ 'disabled': $ctrl.state.step !== ( $ctrl.resolve.texts.length - 1 ) }\"></a> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/apresentation/apresentation.html
// module id = 169
// module chunks = 0